import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useAuthChange, AuthChangeEvent, useAuthStatus } from "./authHooks";
import { Flows } from "./api_client/allauth";

export const URLs = Object.freeze({
  LOGIN_URL: "/account/login",
  LOGIN_REDIRECT_URL: "/summarization-request",
  LOGOUT_REDIRECT_URL: "/",
});

const flow2path: any = {};
flow2path[Flows.LOGIN] = "/account/login";
flow2path[Flows.LOGIN_BY_CODE] = "/account/login/code/confirm";
flow2path[Flows.SIGNUP] = "/account/signup";
flow2path[Flows.VERIFY_EMAIL] = "/account/verify-email";
flow2path[Flows.PROVIDER_SIGNUP] = "/account/provider/signup";

export function pathForFlow(flow: any, typ: any) {
  let key = flow.id;
  if (typeof flow.types !== "undefined") {
    typ = typ ?? flow.types[0];
    key = `${key}:${typ}`;
  }
  const path = flow2path[key] ?? flow2path[flow.id];
  if (!path) {
    throw new Error(`Unknown path for flow: ${flow.id}`);
  }
  return path;
}

export function pathForPendingFlow(auth: any) {
  const flow = auth.data.flows.find((flow: any) => flow.is_pending);
  if (flow) {
    return pathForFlow(flow, undefined);
  }
  return null;
}

function navigateToPendingFlow(auth: any) {
  const path = pathForPendingFlow(auth);
  if (path) {
    return <Navigate to={path} />;
  }
  return null;
}

export function AuthenticatedRoute({ children }: any) {
  const location = useLocation();
  const [, status] = useAuthStatus();
  const next = `next=${encodeURIComponent(
    location.pathname + location.search
  )}`;
  // console.log("status.isAuth::", status.isAuthenticated);
  // console.log("next:", next);
  if (status.isAuthenticated) {
    return children;
  } else {
    return <Navigate to={`${URLs.LOGIN_URL}?${next}`} />;
  }
}

export function AnonymousRoute({ children }: any) {
  const [, status] = useAuthStatus();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // console.log("from anonymous route--------");
  // console.log(location.search);
  // console.log(params.get("next") as string);
  // console.log(location);
  // console.log("---------------");

  if (!status.isAuthenticated) {
    return children;
  } else {
    if (params.get("next")) {
      const url = new URL(params.get("next") as string, window.location.origin);
      url.searchParams.append("skip_redirection", "true");
      const newTarget = url.pathname + url.search;
      return <Navigate to={newTarget} />;
    } else {
      return <Navigate to={URLs.LOGIN_REDIRECT_URL} />;
    }
  }
}

export function AuthChangeRedirector({ children }: any) {
  const [auth, event] = useAuthChange();
  const location = useLocation();
  const params = new URLSearchParams(location.search);


  // console.log('from AuthChangeRedirector---------')
  // console.log("Auth status changed::", event);
  // console.log(window.location.href);
  // console.log(location);
  // console.log(location.search);
  // console.log("---------------");

  switch (event) {
    case AuthChangeEvent.LOGGED_OUT:
      return <Navigate to={URLs.LOGOUT_REDIRECT_URL} />;
    case AuthChangeEvent.LOGGED_IN:
      if (params.get("next")) {
        return <Navigate to={params.get("next") as string} />;
      } else if (params.get("skip_redirection") == "true") {
        return <Navigate to={location.pathname} />;
      } else {
        return <Navigate to={URLs.LOGIN_REDIRECT_URL} />;
      }
    case AuthChangeEvent.FLOW_UPDATED: {
      const pendingFlow = navigateToPendingFlow(auth);
      if (!pendingFlow) {
        throw new Error();
      }
      return pendingFlow;
    }
    default:
      break;
  }
  // ...stay where we are
  return children;
}
